import React, { useState, useEffect } from 'react';
import {Card, Button} from 'react-bootstrap';
import { NavLink, useNavigate } from 'react-router-dom';
import { isAbsoluteURL } from '../libs/urllib';

/**
 * Component that will redirect to a given page after a given time.
 * @param {string} target 
 *    Path to redirect to after timeout expires.
 * @param {string} friendlyName
 *    How to display target to user in sentence "You will be redirected to
 *    {friendlyName} in {timeRemaining} seconds."
 * @param {number} timeout
 *    Number of seconds to wait before redirecting.
 * @param {string} message
 *    Message to display. Optional.
 * @param {function} callback
 *    Callback to execute on redirect.
 */
export default function TimedRedirect({
  target = '/',
  friendlyName = 'the homepage',
  timeout = 3,
  className = '',
  message = null,
  callback = null,
  ...props
}) {
  const [timeRemaining, setTimeRemaining] = useState(timeout);
  const navigate                          = useNavigate();

  /**
   * Set up our countdown.
   */
  useEffect(
    () => {
      // Start a timer.
      let timer = setInterval(
        () => {
          if(timeRemaining <= 0) {
            // Timeout reached.
            if (typeof callback === 'function') {
              callback();
            }
            // Check whether link is absolute, and redirect in the appropriate
            // manner.
            if(isAbsoluteURL(target)) {
              window.location = target;
            }
            else {
              navigate(target);
            }
          }
          else {
            setTimeRemaining(timeRemaining - 1);
          }
        },
        1000
      );
      // Return a cleanup function.
      return () => {
        clearInterval(timer);
      }
    },
  );

  function getMessage() {
    if (message === null) {
      return null;
    }
    else {
      return (
        <>
          { message }<br />
        </>
      );
    }
  }

  function getClassName() {
    return "redirectCard " + className
  }

  return (
    <div className = {getClassName()}>
      <Card
        border = "primary"
      >
        <Card.Body>
          <Card.Text>
            { getMessage() }
            You will be redirected to {friendlyName} in {timeRemaining} seconds.
          </Card.Text>
          <Button
            variant="primary"
            as={NavLink}
            to={target}
          >
            Go now.
          </Button>
        </Card.Body>
      </Card>
    </div>
  );
}